module.exports = __webpack_public_path__ + "static/media/christian-dior-addict-big.1c3d628d.png";